function WarningOutline({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 60 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30.0003 11.3066L50.0803 46H9.92032L30.0003 11.3066ZM30.0003 0.666626L0.666992 51.3333H59.3337L30.0003 0.666626ZM32.667 38H27.3337V43.3333H32.667V38ZM32.667 22H27.3337V32.6666H32.667V22Z" fill=${`"${col}"`} />
    </svg>
  `;

  return baseXml;
}

export default WarningOutline;
